import { Component } from "react"

class OnetimePassword extends Component{
    constructor(props){
        super(props)
        this.name = "ワンタイムパスワード"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 30){
                callbackDialog("エラー",this.name + "は6文字以内にしてください。")
                return false
            }
            if(!/^[0-9]{6}$/.test(this.props)){
                callbackDialog("エラー",this.name + "で使用できる文字列は0～9の6桁です。")
                return false
            }
        }
        return true
    }
}

export default OnetimePassword;